import { render, staticRenderFns } from "./UserPwdForm.vue?vue&type=template&id=e41aa9b2&scoped=true&"
import script from "./UserPwdForm.vue?vue&type=script&lang=js&"
export * from "./UserPwdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41aa9b2",
  null
  
)

export default component.exports